import $api from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";

import { SystemOverviewSubpage } from "@/interfaces/admin/SystemOverviewSubpages";

type Period = "day" | "month";

interface VolumeRequest {
  period?: Period;
  date_start?: string;
  date_end?: string;
}

class SystemEndpoint {
  public overview(key: SystemOverviewSubpage, params: AxiosRequestConfig = {}) {
    return $api.get(`a/system/${key}`, params);
  }

  public statisticTransactionVolume(params?: VolumeRequest | null) {
    const request = {} as AxiosRequestConfig;
    if (params) {
      request.params = params;
    }

    return $api.get("a/system/transaction-volume", request);
  }
}

export default SystemEndpoint;
